import { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { ModuleHeader } from '@/components/ui/module-header';
import { DataTable } from '@/components/ui/data-table';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { api } from '@/lib/api';

export default function SuperAuditPage() {
  const [searchParams] = useSearchParams();
  const [companyId, setCompanyId] = useState(searchParams.get('companyId') ?? '');
  const [action, setAction] = useState('');

  const q = useQuery({
    queryKey: ['super-audit', companyId, action],
    queryFn: async () => {
      const params = new URLSearchParams({ limit: '200' });
      if (companyId) params.set('companyId', companyId);
      if (action) params.set('action', action);
      const r = await api(`/api/v1/super/audit-logs?${params}`);
      if (r.status !== 200) throw new Error('audit');
      return r.data.logs ?? [];
    },
  });

  const columns = useMemo(
    () => [
      {
        key: 'occurredAt',
        label: 'When',
        render: (v) => new Date(String(v)).toLocaleString(),
      },
      { key: 'companyId', label: 'Company', className: 'font-mono text-xs' },
      { key: 'action', label: 'Action' },
      { key: 'userId', label: 'User', className: 'font-mono text-xs' },
      {
        key: 'ipAddress',
        label: 'IP',
        render: (v) => String(v ?? '—'),
        className: 'font-mono text-xs',
      },
    ],
    []
  );

  return (
<div className="space-y-6 motion-enter">
        <ModuleHeader
          title="Audit logs"
          description="Cross-tenant system and user action trail."
          icon="ScrollText"
          metrics={[{ label: 'Rows', value: q.data?.length ?? 0 }]}
        />

        <div className="flex flex-wrap items-center gap-3">
          <Input
            className="max-w-[200px]"
            placeholder="Filter companyId"
            value={companyId}
            onChange={(e) => setCompanyId(e.target.value)}
          />
          <Input
            className="max-w-[200px]"
            placeholder="Filter action"
            value={action}
            onChange={(e) => setAction(e.target.value)}
          />
        </div>

        <Card>
          <CardContent className="pt-6">
            <DataTable columns={columns} data={q.data ?? []} emptyMessage="No audit logs" />
          </CardContent>
        </Card>
      </div>
);
}
